<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » 建物・カテゴリ情報詳細（追加・編集）の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

  <mat-card appearance="outlined" class="manual-card">
    <mat-card-header>
      <mat-card-title><span>建物・カテゴリ情報詳細（追加・編集）の説明</span></mat-card-title>
    </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/hall-dialog-ja.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 更新ボタン
        </div>
        <div class="manual-explain">
          クリックすることで編集内容が更新されます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> 閉じるボタン
        </div>
        <div class="manual-explain">
          クリックすることでダイアログを閉じます。<br>
          その際、編集した内容は保存されません。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> ID
        </div>
        <div class="manual-explain">
          IDを設定します。<br>
          <span class="manual-explain-notes">※必須項目</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> 説明
        </div>
        <div class="manual-explain">
          情報についての説明を設定します。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> 名称
        </div>
        <div class="manual-explain">
          名称を設定します。<br>
          編集ボタンから<a [href]="nameDialogLink">編集用ダイアログ</a>を開き設定します。<br>
          <span class="manual-explain-notes">※必須項目</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> マップ情報
        </div>
        <div class="manual-explain">
          マップ情報を設定します。<br>
          マップ内の検索キーワード、または緯度軽度から指定可能です。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/G.png"> MAP位置に表示する
        </div>
        <div class="manual-explain">
          チェックを入れることで、Google Mapに位置を表示します。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/H.png"> メニュー表示タイプ
        </div>
        <div class="manual-explain">
          ユーザーシステム「メニュー」上の表示方法を設定します。<br>
          「ガイドに表示する」か「メニューに表示する」のいずれかを選択します。<br>
          　「ガイドに表示する」　･･･ 建物・カテゴリ名称がメニューの「ガイド」にまとめられます。<br>
          　「メニューに表示する」･･･ メニューに建物・カテゴリ名称が個別で表示されます。<br>
          <span class="manual-explain-notes">※必須項目</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/I.png"> 「メニュー」の使用について
        </div>
        <div class="manual-explain">
          「メニュー表示タイプ」で「メニューに表示する」を選択した場合に表示されます。<br>
          　登録する建物・カテゴリ情報に紐づくコンテンツの使用範囲（メニューへの表示有無）を選択します。<br>
          　「使わない」　･･･ ユーザーサイトのメニューに、この建物・カテゴリ情報に紐づくコンテンツを表示したくない場合<br>
          　「PCとスマホで使う」･･･ ユーザーサイトのメニューに、この建物・カテゴリ情報に紐づくコンテンツを表示したい場合<br>
          　「PCで使う」･･･ ユーザーサイト（PCサイズ）のメニューに、この建物・カテゴリ情報に紐づくコンテンツを表示したい場合<br>
          　「スマホで使う」･･･ ユーザーサイト（スマホサイズ）のメニューに、この建物・カテゴリ情報に紐づくコンテンツを表示したい場合<br>
          <span class="manual-explain-notes">※必須項目</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/J.png"> メニュー表示範囲指定（緯度経度からの距離（m））
        </div>
        <div class="manual-explain">
          メニュー表示タイプから「メニューに表示する」を選択した時に表示されます。<br>
          施設情報の位置（緯度経度）と現在地点との距離を計測し、現在地点が指定した範囲内の時にメニューを表示します。<br>
          <span class="manual-explain-notes">（※建物・カテゴリ情報の位置（緯度経度）ではない点にご注意ください）</span><br>
          　「常に表示」･･･ 施設情報の位置に関係なくメニューに建物・カテゴリ名称を表示します。<br>
          　「半径200m以内表示」･･･ 施設情報の位置と現在地の距離が200m以内の時にメニューに建物・カテゴリ名称を表示します。<br>
          　「半径500m以内表示」･･･ 施設情報の位置と現在地の距離が500m以内の時にメニューに建物・カテゴリ名称を表示します。<br>
          　「半径1000m以内表示」･･･ 施設情報の位置と現在地の距離が1000m以内の時にメニューに建物・カテゴリ名称を表示します。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/K.png"> 登録画像をメニューアイコンとして利用する
        </div>
        <div class="manual-explain">
          メニューに表示されるデフォルトアイコンを変更したい場合にチェックします。<br>
          チェックをした場合、アップロード画像をアイコンにすることができます。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/L.png"> メニューアイコン画像ファイル
        </div>
        <div class="manual-explain">
          メニューに表示するアイコンを選択します。<br>
          （アイコンはデフォルトの画像か登録した画像から選択できます。）<br>
          ファイル追加ボタンからファイルを選択します。<br>
          ※登録した画像を使用する場合は、画像ファイルは、<a [href]="uploaderLink">アップロードファイル画面</a>で事前にアップロードしてある必要があります。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/M.png"> カスタム画像ファイルを使用する
        </div>
        <div class="manual-explain">
          チェックをした場合、建物・カテゴリページに画像を表示することができます。<br>
          画像は「カスタム画像ファイル」で設定します。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/N.png"> カスタム画像ファイル
        </div>
        <div class="manual-explain">
          建物・カテゴリページに表示する画像を選択します。<br>
          登録した画像を使用する場合は、「カスタム画像ファイルを使用する」にチェックします。
          ファイル追加ボタンからファイルを選択します。<br>
          ※登録した画像を使用する場合は、画像ファイルは、<a [href]="uploaderLink">アップロードファイル画面</a>で事前にアップロードしてある必要があります。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/O.png"> 有償コンテンツを表示する
        </div>
        <div class="manual-explain">
          この建物・カテゴリ情報に紐づくコンテンツを有償化する場合はチェックを入れます。<br>
          チェックを入れると購入手続きが必要となり、購入済みとなった場合にメニューにコンテンツが表示されるようになります。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/P.png"> 詳細
        </div>
        <div class="manual-explain">
          「有償コンテンツを表示する」にチェックを入れた場合に表示されます。<br>
          有償コンテンツの詳細を設定します。<br>
          編集ボタンから<a [href]="descDialogLink">編集用ダイアログ</a>を開き設定します。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/Q.png"> 販売期間
        </div>
        <div class="manual-explain">
          「有償コンテンツを表示する」にチェックを入れた場合に表示されます。<br>
          有償コンテンツの販売期間（開始日／終了日）を設定します。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/R.png"> 価格
        </div>
        <div class="manual-explain">
          「有償コンテンツを表示する」にチェックを入れた場合に表示されます。<br>
          有償コンテンツの価格を設定します。<br>
          <span class="manual-explain-notes">※「有償コンテンツを表示する」がチェックありの場合は必須項目</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/S.png"> 有効期間
        </div>
        <div class="manual-explain">
          「有償コンテンツを表示する」にチェックを入れた場合に表示されます。<br>
          有償コンテンツ購入後の閲覧可能期間を選択します。<br>
          <span class="manual-explain-notes">※「有償コンテンツを表示する」がチェックありの場合は必須項目</span>
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Building/Category Information Details (Add/Edit) Description
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

  <mat-card appearance="outlined" class="manual-card">
    <mat-card-header>
      <mat-card-title><span>Building/Category Information Details (Add/Edit) Description</span></mat-card-title>
    </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_hall-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Update Button
        </div>
        <div class="manual-explain">
          Clicking this button will apply the edited content.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Close Button
        </div>
        <div class="manual-explain">
          Click to close the dialog.<br>
          Any unsaved changes will not be retained.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> ID
        </div>
        <div class="manual-explain">
          Set the ID.<br>
          <span class="manual-explain-notes">※Required field</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Description
        </div>
        <div class="manual-explain">
          Set the description for the information.<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> Name
        </div>
        <div class="manual-explain">
          Set the name.<br>
          Click the edit button to open the <a [href]="nameDialogLink">edit dialog</a> and set the name.<br>
          <span class="manual-explain-notes">※Required field</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> Map Information
        </div>
        <div class="manual-explain">
          Set the map information.<br>
          You can specify by map search keyword or by latitude/longitude.<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/G.png"> Display Location on MAP Page
        </div>
        <div class="manual-explain">
          Check this box to display Google Maps with a pin on the MAP page.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/H.png"> Menu Display Type
        </div>
        <div class="manual-explain">
          Set how it appears on the user system "Menu".<br>
          Select either "Display in Guide" or "Display in Menu".<br>
          　"Display in Guide"　･･･ Building/category names are grouped under "Guide" in the menu.<br>
          　"Display in Menu"･･･ Building/category names are displayed individually in the menu.<br>
          <span class="manual-explain-notes">※Required field</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/I.png"> Using the "Menu"
        </div>
        <div class="manual-explain">
          This will be displayed when you select "Display in Menu" in "Menu display type".<br>
          　Select the scope of use of the content linked to the building and category information you are registering (whether or not to display it in the menu).<br>
          　"Don't use" ･･･ If you do not want to display content related to this building/category information in the user site menu<br>
          　"Use on PC and smartphone" ･･･ If you want to display content related to this building/category information in the menu of your site<br>
          　"Use on PC" ･･･ If you want to display content related to this building/category information in the menu of your user site (PC size)<br>
          　"Use on smartphone" ･･･ If you want to display content related to this building/category information in the menu of your user site (smartphone size)<br>
          <span class="manual-explain-notes">※ Required field</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/J.png"> Specify Menu Display Range (Distance from Latitude/Longitude (m))
        </div>
        <div class="manual-explain">
          This appears when "Display in Menu" is selected for Menu Display Type.<br>
          The menu will be displayed if the current location is within the specified range from the facility's location (latitude/longitude).<br>
          <span class="manual-explain-notes"> (※Please note this is not the location of the building/category information)</span><br>
          　"Always Display"･･･ Building/category names are always displayed in the menu, regardless of facility location.<br>
          　"Display within 200m"･･･ Building/category names are displayed in the menu when the current location is within 200m of the facility's location.<br>
          　"Display within 500m"･･･ Building/category names are displayed in the menu when the current location is within 500m of the facility's location.<br>
          　"Display within 1000m"･･･ Building/category names are displayed in the menu when the current location is within 1000m of the facility's location.<br>
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/K.png"> Use the registered image as a menu icon
        </div>
        <div class="manual-explain">
          Check this box if you want to change the default icon displayed in the menu.<br>
          If checked, the uploaded image can be used as an icon.<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/L.png"> Menu Icon Image File
        </div>
        <div class="manual-explain">
          Select the icon you want to display in the menu.<br>
          （You can choose the icon from the default image or an image you registered.）<br>
          Select the file using the Add File button.<br>
          ※If you want to use a registered image, the image file must be uploaded in advance on the <a [href]="uploaderLink">Upload File screen</a>.<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/M.png"> Use custom image file
        </div>
        <div class="manual-explain">
          If checked, images can be displayed on building and category pages.<br>
          Images are set in "Custom Image File".<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/N.png"> Custom Image File
        </div>
        <div class="manual-explain">
          Select the image to display on the building/category page.<br>
          To use a registered image, check "Use custom image file".
          Select a file from the "Add File" button.<br>
          ※If using a registered image, the image file must be <a [href]="uploaderLink">uploaded in advance on the Upload Files screen</a>.<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/O.png"> Display Paid Content
        </div>
        <div class="manual-explain">
          Check this box if you want to make the content linked to this building/category information paid.<br>
          If you check this box, you will be required to go through the purchase process, and the content will appear in the menu once it has been purchased.<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/P.png"> Detail
        </div>
        <div class="manual-explain">
          This will be displayed if you check "Display Paid Content."<br>
          Set the details of the paid content.<br>
          Click the Edit button to open the <a [href]="descDialogLink">edit dialog</a> and set the settings.<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/Q.png"> Sales Period
        </div>
        <div class="manual-explain">
          This will be displayed if you check "Display Paid Content."<br>
          Set the sales period (start date/end date) for the paid content.<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/R.png"> Price
        </div>
        <div class="manual-explain">
          This will be displayed if you check "Display Paid Content."<br>
          Set the price for paid content.<br>
          <span class="manual-explain-notes">※Required if "Display Paid Content" is checked</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/S.png"> Validity Period
        </div>
        <div class="manual-explain">
          This will be displayed if you check "Display Paid Content."<br>
          Select the viewing period for paid content after purchase.<br>
          <span class="manual-explain-notes">※Required if "Display Paid Content" is checked</span>
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
